import { storeToRefs } from 'pinia'
import { useFantasyLeaderboardStore } from '@/stores/fantasy/leaderboard'
import { useFantasySeasonStore } from '@/stores/fantasy/season'
import { FANTASY_SCREENS } from './constants'
import { useFantasyAnalytics } from './use-fantasy-analytics'

export const useFantasySeasonLeaderboard = () => {
  const { $dialog } = useNuxtApp()
  const fantasySeasonStore = useFantasySeasonStore()
  const fantasyLeaderboardStore = useFantasyLeaderboardStore()
  const { trackLeaderboardClick } = useFantasyAnalytics()
  const { data: season } = storeToRefs(fantasySeasonStore)

  const handleOpenSeasonLeaderboard = () => {
    trackLeaderboardClick({
      leaderboardType: 'season',
      screenName: FANTASY_SCREENS.main
    })

    $dialog({
      wrapper: null,
      scrollLock: false,
      content: defineAsyncComponent(
        () => import('~/components/fantasy/popups/day-leaders/index.vue')
      ),
      contentProps: {
        rewards: season.value?.rewards ?? [],
        variant: 'season'
      },
      fetchData: () => {
        const seasonId = season.value?.id
        if (!seasonId) return Promise.resolve([])
        return fantasyLeaderboardStore.fetchItems(seasonId)
      }
    })
  }

  return {
    handleOpenSeasonLeaderboard
  }
}
